export const FETCH_EMERGENCY_BROADCASTS = 'emergencybroadcast/FETCH_EMERGENCY_BROADCASTS';
export const FETCH_EMERGENCY_BROADCASTS_SUCCESS = 'emergencybroadcast/FETCH_EMERGENCY_BROADCASTS_SUCCESS';
export const SAVE_EMERGENCY_BROADCAST = 'emergencybroadcast/SAVE_EMERGENCY_BROADCAST';
export const SAVE_EMERGENCY_BROADCAST_SUCCESS = 'emergencybroadcast/SAVE_EMERGENCY_BROADCAST_SUCCESS';
export const UPDATE_EMERGENCY_BROADCAST = 'emergencybroadcast/UPDATE_EMERGENCY_BROADCAST';
export const UPDATE_EMERGENCY_BROADCAST_SUCCESS = 'emergencybroadcast/UPDATE_EMERGENCY_BROADCAST_SUCCESS';
